var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPinterestOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.268 2C6.87 2 4 5.513 4 9.343c0 1.776.977 3.991 2.542 4.694.237.108.367.062.42-.162.046-.17.252-.988.351-1.374a.36.36 0 00-.083-.348c-.52-.61-.932-1.721-.932-2.764 0-2.671 2.091-5.265 5.65-5.265 3.077 0 5.23 2.03 5.23 4.934 0 3.281-1.71 5.551-3.932 5.551-1.23 0-2.145-.98-1.855-2.192.351-1.444 1.04-2.997 1.04-4.038 0-.934-.52-1.706-1.581-1.706-1.252 0-2.267 1.259-2.267 2.949 0 1.073.374 1.798.374 1.798l-1.469 6.03c-.389 1.606.053 4.207.091 4.43.024.125.16.163.237.062.122-.162 1.618-2.331 2.038-3.899.153-.571.78-2.887.78-2.887.412.756 1.602 1.39 2.87 1.39 3.77 0 6.496-3.367 6.496-7.544C19.986 4.996 16.611 2 12.268 2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinterestOutline);
export default __webpack_public_path__ + "76d973b404389c310daf53c7d026b39d.svg";
export { ForwardRef as ReactComponent };